import { AutogenLayoutOfficeWorkersCompensationReport } from "./autogen/AutogenLayoutOfficeWorkersCompensationReport";

export class OfficeWorkersCompensationReport extends AutogenLayoutOfficeWorkersCompensationReport {
    
    /** Event handler for report type switch changes */
    reportTypeChanged(): void {
        const isDetailed = this.switchReportType ? this.switchReportType.checked : true;
        if(!isDetailed) {
            // Clear SSN option when switching to summary report
            this.checkboxIncludeSsn.checked = false;
            this.checkboxIncludeSsn.enabled = false;
        } else {
            this.checkboxIncludeSsn.enabled = true;
        }
    }

    /** Event handler for Include Settlement History checkbox changes */
    checkboxIncludeSettlementHistoryOnChange(): void {
        this.excludabletextboxPayees.textbox.clear();
        
        if (this.checkboxIncludeSettlementHistory.checked) {
            // When including settlement history, use transfer-to-settlement payee lookup
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        } else {
            // When office payroll only, use office payee lookup
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}